import { RadioGroup } from "@headlessui/react";
import Radio, { RadioVariant } from "shared/ui/radio";
import { concatClassnames } from "shared/utils/concatClassnames";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { CheckoutWarrantyListProps } from ".";

type WidthMapping = {
  [key: number]: number;
};

const widthMapping: WidthMapping = {
  0: 430,
  1: 450,
  2: 500,
  3: 110,
};

export const WarrantyListSkeleton = ({
  className = "",
}: CheckoutWarrantyListProps) => {
  return (
    <RadioGroup
      value={null}
      onChange={() => {}}
      className={concatClassnames(
        "gg-overflow-hidden gg-grid gg-gap-y-4 gg-cursor-none gg-touch-none gg-pointer-events-none",
        className
      )}
    >
      {[...Array(4)].map((_, index) => (
        <RadioGroup.Option key={index} value="">
          <div className="gg-flex gg-items-center gg-gap-x-5">
            <Radio
              variant={RadioVariant.CIRCLE}
              disabled
              id="asd"
              onChange={() => {}}
              className={"gg-shrink-0"}
            />
            <label
              className="gg-h-[28px] sm:gg-h-[20px]"
              style={{ width: widthMapping[index] }}
            >
              <Skeleton className="flex-1 gg-h-full" />
            </label>
          </div>
        </RadioGroup.Option>
      ))}
    </RadioGroup>
  );
};
